/**
 * Builds the `onClose` callback for MUI's `Dialog` so that only the `Escape` key dismisses
 * the modal/dialog.
 *
 * Backdrop clicks are deliberately ignored: modals and dialogs regularly hold unsaved form
 * input, and a stray click next to them must not throw it away.
 *
 * @param onClose called when the user pressed `Escape`
 * @returns a MUI `Dialog` `onClose` handler
 *
 * @example
 * <MuiDialog open={open} onClose={closeModalOnEscapeKeyDown(onClose)}>...</MuiDialog>
 */
export const closeModalOnEscapeKeyDown = (onClose) => (_event, reason) => {
    if (reason === 'escapeKeyDown') {
        onClose === null || onClose === void 0 ? void 0 : onClose();
    }
};
